import React from 'react';
import PropTypes from 'prop-types';
import {
  TabCardBlock,
  TabCardSmall,
} from 'web-ui-components/lib/navigation/tab-cards';
import { SubsectionHeading } from 'web-ui-components/lib/typography/headings';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import PrintHelper from 'print-helper-lib';

const TabularTransactionCategoryView = ({
  brandId,
  tabs,
  currentTab,
  onClick,
  hasDivider,
}) => {
  return (
    <div className="print-only--inline-block">
      <TabCardBlock flush>
        <SubsectionHeading>
          <span className="u-text-align-center">Transaction view:</span>
        </SubsectionHeading>
        {tabs.map((tab) => (
          <TabCardSmall
            key={tab.id}
            isActive={tab.id === currentTab}
            onClick={() => {
              onClick(tab.id);
            }}
            label={tab.title}
            iconType={tab.icon}
          />
        ))}
      </TabCardBlock>
      {hasDivider && <Divider />}
      <PrintHelper brandId={brandId} showPrintBottomIcon={false} />
    </div>
  );
};

TabularTransactionCategoryView.propTypes = {
  brandId: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  currentTab: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  hasDivider: PropTypes.bool,
};

export default TabularTransactionCategoryView;
